import ApplicationComponent from "legacy/ApplicationComponent"
import FormGroup from "legacy/FormGroup"
import LegacyButton from "legacy/LegacyButton"
import NextButton from "legacy/boater-reservation-flow/NextButton"
import {
  afterSetState,
  centsToDollars,
  isEmpty,
  titleCase,
} from "legacy/helpers.es6"
import SearchCustomerForm from "legacy/manage/SearchCustomerForm"
import AddCustomerNote from "legacy/sales/AddCustomerNote"
import PaymentSelectCart from "legacy/sales/PaymentSelectCart"
import ReceiptPrinterChooser from "legacy/sales/ReceiptPrinterChooser"
import SaleCheckoutItemsList from "legacy/sales/SaleCheckoutItemsList"
import { validatorFactory } from "legacy/validatorFactory"
// isEmpty import moved to combined import above
import PropTypes from "prop-types"
import React from "react"

class SaleCheckout extends ApplicationComponent {
  constructor(args) {
    super(args)
    this.state = {
      customerCards: [],
      activeSection: "items",
      customerError: false,
      paymentError: false,
      itemError: false,
      invalidQuantity: [],
      loadingCustomerCards: false,
    }
    this.handleSectionClick = this.handleSectionClick.bind(this)
    this.handleUpdateCustomer = this.handleUpdateCustomer.bind(this)
    this.trackEvent = this.trackEvent.bind(this)
    this.shouldShowGuestEmailInput = this.shouldShowGuestEmailInput.bind(this)
    this.handleUpdatePaymentMethod = this.handleUpdatePaymentMethod.bind(this)
    this.handleCheckout = this.handleCheckout.bind(this)
    this.needsToTokenizeCard = this.needsToTokenizeCard.bind(this)
    this.receiptPrinterAvailable = this.receiptPrinterAvailable.bind(this)
    this.validateEmptyCart = this.validateEmptyCart.bind(this)
    this.validateDisplayedPricing = this.validateDisplayedPricing.bind(this)
    this.validateItemQuantities = this.validateItemQuantities.bind(this)
    this.validateCustomer = this.validateCustomer.bind(this)
    this.validateGuestEmail = this.validateGuestEmail.bind(this)
    this.validatePaymentMethod = this.validatePaymentMethod.bind(this)
    this.invalidItems = this.invalidItems.bind(this)
    this.renderSelectedCustomer = this.renderSelectedCustomer.bind(this)
    this.getCreditCards = this.getCreditCards.bind(this)
    this.renderContinueButton = this.renderContinueButton.bind(this)
    this.renderSectionAdvanceButton = this.renderSectionAdvanceButton.bind(this)
    this.trackEmailInput = this.trackEmailInput.bind(this)
    this.renderSectionHeaderButton = this.renderSectionHeaderButton.bind(this)
    this.renderTotal = this.renderTotal.bind(this)
    this.renderPrintReceiptSelector = this.renderPrintReceiptSelector.bind(this)

    this.validator = validatorFactory({ autoForceUpdate: this })
    this.paymentSelect = null
    this.setPaymentSelectRef = (element) => {
      this.paymentSelect = element
    }
  }

  trackEvent(event) {
    // Note: Amplitude is loaded globally
    Amplitude.trackEvent(`web_pos:${event}`)
  }

  handleSectionClick(section) {
    if (this.state.activeSection === section) {
      this.setState({ activeSection: "" })
    } else {
      this.setState({ activeSection: section })
    }
  }

  handleUpdateCustomer(customer) {
    const isGuest = this.props.isGuest()
    const isContact = customer && customer.encodedId

    if (!customer || isGuest) {
      this.setState({ customerCards: [] })
    } else if (customer && customer.encodedId) {
      this.getCreditCards(customer)
    }
    this.props.handleUpdateCustomer(customer)
    if (customer) {
      this.setState({ activeSection: "payment" })
    }

    if (isGuest || isContact) {
      const cardId = isContact ? "select_card" : "add_new_card"
      const paymentMethod = { ...this.props.cart.paymentMethod, cardId }
      afterSetState(() => {
        this.props.handleUpdatePaymentMethod(paymentMethod)
      })
    }
  }

  handleUpdatePaymentMethod(paymentMethod) {
    if (["cash", "check"].includes(paymentMethod.type)) {
      // for cash and check, just set it, no additional handling needed
      this.props.handleUpdatePaymentMethod(paymentMethod)
    } else if (paymentMethod.error) {
      // tokenizing card failed
      this.props.handleLoading(false)
    } else if (paymentMethod.cardId) {
      // either a real card_id or 'add_new_card'
      this.props.handleUpdatePaymentMethod(paymentMethod)

      // this is the stripeSuccess callback, so now call checkout again after tokenizing card
      if (paymentMethod.stripeToken) {
        afterSetState(() => {
          this.handleCheckout()
        })
      }
    }
  }

  handleCheckout() {
    if (!this.validateEmptyCart()) return
    if (!this.validateItemQuantities()) return
    if (!this.validateCustomer()) return
    if (!this.validateGuestEmail()) return
    if (!this.validateDisplayedPricing()) return

    if (this.needsToTokenizeCard()) {
      // this will create the stripe payment method and call handleUpdatePaymentMethod
      // handleUpdatePaymentMethod calls this method again to continue the validation & checkout process
      this.props.handleLoading(true)
      this.paymentSelect.tokenizeCard()
      return
    }

    if (this.validatePaymentMethod()) {
      this.props.handleCheckout()
    }
  }

  needsToTokenizeCard() {
    return (
      this.props.cart.paymentMethod.type === "credit" &&
      this.props.cart.paymentMethod.cardId === "add_new_card" &&
      !this.props.cart.paymentMethod.stripeToken
    )
  }

  receiptPrinterAvailable() {
    return $context.receiptPrinters && $context.receiptPrinters.length > 0
  }

  validateEmptyCart() {
    if (this.props.cart.items.length < 1) {
      this.setState({
        activeSection: "items",
        itemError: true,
      })
      return false
    }
    return true
  }

  validateDisplayedPricing() {
    if (this.props.pricingError || this.props.loadingPrices) {
      this.setState({
        activeSection: "items",
        itemError: true,
      })
      return false
    }
    return true
  }

  validateItemQuantities() {
    if (this.invalidItems().length > 0) {
      this.setState({
        activeSection: "items",
        invalidQuantity: this.invalidItems(),
      })
      return false
    }
    return true
  }

  validateCustomer() {
    if (!this.props.cart.customer) {
      this.setState({
        activeSection: "customer",
        customerError: true,
        itemError: false,
      })
      return false
    }
    return true
  }

  validateGuestEmail() {
    if (
      this.props.cart.customer &&
      !this.props.cart.customer.encodedId &&
      this.props.cart.customer.email &&
      this.props.cart.customer.email.length > 0 &&
      !this.validator.allValid()
    ) {
      this.setState({
        activeSection: "payment",
        paymentError: false,
      })
      this.validator.showMessages()
      return false
    }
    return true
  }

  validatePaymentMethod() {
    const paymentMethod = this.props.cart.paymentMethod
    const checkOrCash = ["cash", "check"].includes(paymentMethod.type)
    const credit = paymentMethod.type === "credit"
    const existingCreditCard =
      credit &&
      paymentMethod.cardId !== "" &&
      paymentMethod.cardId !== "add_new_card"
    const newCreditCard =
      credit &&
      paymentMethod.cardId === "add_new_card" &&
      paymentMethod.stripeToken
    const validPayment = checkOrCash || existingCreditCard || newCreditCard

    if (!validPayment) {
      this.setState({
        activeSection: "payment",
        paymentError: true,
        customerError: false,
      })
    }
    return validPayment
  }

  invalidItems() {
    return (this.props.cart.items || []).filter((item) => item.quantity <= 0)
  }

  renderSelectedCustomer() {
    if (this.props.cart.customer) {
      return (
        <div className="grid grid-cols-2 p-3">
          <p>{this.props.cart.customer.name}</p>
          <LegacyButton
            className="btn-sm mr-2 justify-self-end"
            type="tertiary"
            aria-label="remove customer"
            iconOnly={true}
            icon="fa-xmark text-xs"
            iconStyle="solid"
            onClick={() => this.handleUpdateCustomer(null)}
          />
          <p className="font-semibold">{this.props.cart.customer.email}</p>
        </div>
      )
    }
  }

  getCreditCards(customer) {
    this.setState({ loadingCustomerCards: true })
    // This legacy endpoint only returns Cards. We can remove this when we want to support Bank Accounts in Sales.
    // Note: jQuery ($) is loaded globally
    $.get(
      `${$context.manageContactsPath}/${customer.encodedId}/cards/legacy`,
      (data) => {
        this.setState({ customerCards: data, loadingCustomerCards: false })
      },
      "json"
    )
  }

  renderContinueButton() {
    switch (this.state.activeSection) {
      case "items":
        return this.renderSectionAdvanceButton("customer")
      case "customer":
        return this.renderSectionAdvanceButton("payment")
      case "payment":
        return (
          <NextButton
            processing={this.props.processing}
            click={() => this.handleCheckout()}
            icon=""
            btnClass="btn btn-primary w-full"
            text="Checkout"
            processingText="Processing..."
          />
        )
    }
  }

  renderSectionAdvanceButton(section) {
    return (
      <LegacyButton
        type="primary"
        className="w-full"
        onClick={() => this.handleSectionClick(section)}
      >
        {`Continue to select ${section}`}
      </LegacyButton>
    )
  }

  shouldShowGuestEmailInput() {
    const customerSelected = this.props.cart.customer
    const customerAlreadyExists =
      this.props.cart.customer && this.props.cart.customer.id
    return customerSelected && !customerAlreadyExists
  }

  trackEmailInput(email) {
    const validEmailFormat = email.toLowerCase().match(/^\S+@\S+\.\S+$/)
    if (validEmailFormat) {
      this.trackEvent("guest_sale_email_entered")
    }
  }

  renderSectionHeaderButton(section) {
    let sectionName = titleCase(section)
    if (section === "items") {
      sectionName =
        titleCase(section) + " (" + this.props.cart.items.length + ")"
    }
    const isSectionActive = this.state.activeSection === section
    return (
      <button
        type="button"
        className="btn my-5 flex h-8 items-center gap-2 bg-transparent"
        onClick={() => this.handleSectionClick(section)}
      >
        {isSectionActive ? (
          <i className={"fa-solid fa-chevron-down"} style={{ fontSize: 8 }} />
        ) : (
          <i className={"fa-solid fa-chevron-right"} style={{ fontSize: 12 }} />
        )}
        <h3 className="m-0 text-base font-semibold">{sectionName}</h3>
      </button>
    )
  }

  renderTotal() {
    // Note: centsToDollars is loaded globally
    if (this.props.loadingPrices || !this.props.fetchedPricing) {
      return (
        <div className="py-2 text-center text-gray-600">
          <p className="mb-2 text-base">Loading Total Price...</p>
          <i className="fa-solid fa-spinner-third fa-spin" />
        </div>
      )
    } else if (
      this.props.fetchedPricing.totalPrice &&
      !isEmpty(this.props.cart.items)
    ) {
      return (
        <p className="mt-2 text-center text-2xl font-semibold">
          {centsToDollars(this.props.fetchedPricing.totalPrice)}
        </p>
      )
    } else {
      return <p className="mt-2 text-center text-2xl font-semibold">$0.00</p>
    }
  }

  // This component is used to select a printer for printing receipts, or not printing.
  // It will only render itself onscreen if there are printers available, so you can always include it.
  renderPrintReceiptSelector() {
    if (this.receiptPrinterAvailable()) {
      return (
        <div>
          <hr />
          <div className="flex flex-row justify-between">
            <ReceiptPrinterChooser
              title="Print Paper Receipt?"
              noneOptionTitle="No Receipt"
              alwaysShow={true}
              printers={$context.receiptPrinters}
              printerId={this.props.receiptPrinterId}
              handlePrinterSelection={this.props.handleUpdateReceiptPrinterId}
            />
          </div>
        </div>
      )
    }
  }

  render() {
    return (
      <div>
        <h2 className="sr-only">Check Out</h2>
        {this.renderSectionHeaderButton("items")}
        <hr className="m-0" />
        {this.state.activeSection === "items" && (
          <div>
            {this.state.itemError && this.props.cart.items.length < 1 && (
              <p className="text-status-red">
                Please add at least 1 item before checking out.
              </p>
            )}
            <SaleCheckoutItemsList
              items={this.props.cart.items}
              invalidItems={this.invalidItems()}
              handleUpdateItemInCart={this.props.handleUpdateItemInCart}
              handleRemoveFromCart={this.props.handleRemoveFromCart}
              invalidQuantity={this.state.invalidQuantity}
              loadingPrices={this.props.loadingPrices}
              pricingError={this.props.pricingError}
              fetchedPricing={this.props.fetchedPricing}
              handleRetry={this.props.handleRetry}
            />
            {this.state.itemError && this.props.loadingPrices && (
              <p className="text-status-red py-2">
                Please wait for prices to load before checking out.
              </p>
            )}
            <AddCustomerNote
              handleUpdateCustomerNote={this.props.handleUpdateNote}
              note={this.props.note}
            />
          </div>
        )}
        <div className="flex items-center justify-between">
          {this.renderSectionHeaderButton("customer")}
          {this.props.cart.customer ? (
            <p className="m-0 pr-3">{this.props.cart.customer.name}</p>
          ) : (
            ""
          )}
        </div>
        <hr className="m-0" />
        {this.state.activeSection === "customer" && (
          <div className="pt-2">
            {this.renderSelectedCustomer()}
            {this.state.customerError && !this.props.cart.customer && (
              <p className="text-status-red">
                Please select or add a new customer before checking out.
              </p>
            )}
            {!this.props.cart.customer && (
              <div>
                <SearchCustomerForm
                  selectContact={this.handleUpdateCustomer}
                  isSafeHarborLocation={$context.isSafeHarborLocation}
                  filterContactsPath={$context.filterContactsPath}
                  manageContactsPath={$context.manageContactsPath}
                  brewerImportPath={$context.brewerImportPath}
                  userImportPath={$context.userImportPath}
                  twoColumnView={true}
                  trackEvent={this.trackEvent}
                />
                <p className="mt-2">
                  Or checkout as a
                  <button
                    type="button"
                    className="ml-1 bg-transparent p-0 text-blue-700"
                    onClick={() => {
                      this.handleUpdateCustomer({ name: "Guest" })
                      this.trackEvent("guest_selected")
                    }}
                  >
                    {" "}
                    guest{" "}
                  </button>
                  , saving no customer information.
                </p>
              </div>
            )}
          </div>
        )}
        <div className="flex items-center justify-between">
          {this.renderSectionHeaderButton("payment")}
        </div>
        <hr className="m-0" />
        {this.state.activeSection === "payment" && (
          <div>
            {this.state.paymentError && (
              <p className="text-status-red">
                Please select a payment method before checking out.
              </p>
            )}
            <PaymentSelectCart
              cart={this.props.cart}
              loadingPrices={this.props.loadingPrices}
              customerCards={this.state.customerCards}
              cartTotal={this.props.fetchedPricing.totalPrice}
              handleUpdatePaymentMethod={this.handleUpdatePaymentMethod}
              isGuest={this.props.isGuest}
              ref={this.setPaymentSelectRef}
              loadingCustomerCards={this.state.loadingCustomerCards}
            />
            {this.shouldShowGuestEmailInput() && (
              <div className="py-2">
                <p>
                  Enter email to send receipt and save customer information
                  (optional).
                </p>
                <FormGroup
                  label="Email"
                  labelClassName="mt-1 w-24"
                  name="email"
                  onBlur={(event) => this.trackEmailInput(event.target.value)}
                  onChange={(event) =>
                    this.handleUpdateCustomer({
                      ...this.props.cart.customer,
                      email: event.target.value,
                    })
                  }
                  className="mt-5 flex gap-x-4"
                  required={false}
                  validation={this.validator.message(
                    "email",
                    this.props.cart.customer.email,
                    "email"
                  )}
                  value={this.props.cart.customer.email}
                />
              </div>
            )}
            {this.renderPrintReceiptSelector()}
          </div>
        )}
        {this.state.activeSection === "payment" && <hr className="m-0" />}
        {this.renderTotal()}
        {this.props.pricingError && (
          <div className="flex items-center">
            <p className="m-0 p-3 text-red-700">{this.props.pricingError}</p>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => this.props.handleRetry()}
            >
              Retry
            </button>
          </div>
        )}
        {this.renderContinueButton()}
        {this.props.createError && (
          <p className="text-status-red">{this.props.createError}</p>
        )}
      </div>
    )
  }
}

SaleCheckout.propTypes = {
  cart: PropTypes.shape({
    items: PropTypes.array.isRequired,
    customer: PropTypes.shape({
      name: PropTypes.string,
      email: PropTypes.string,
      encodedId: PropTypes.string,
      id: PropTypes.string,
    }),
    paymentMethod: PropTypes.shape({
      type: PropTypes.string.isRequired,
      cardId: PropTypes.string,
      checkNumber: PropTypes.string,
      stripeToken: PropTypes.string,
    }).isRequired,
  }).isRequired,
  fetchedPricing: PropTypes.object,
  loadingPrices: PropTypes.bool,
  pricingError: PropTypes.string,
  processing: PropTypes.bool,
  createError: PropTypes.string,
  note: PropTypes.string,
  receiptPrinterId: PropTypes.string,
  isGuest: PropTypes.func.isRequired,
  handleUpdateCustomer: PropTypes.func.isRequired,
  handleUpdatePaymentMethod: PropTypes.func.isRequired,
  handleUpdateItemInCart: PropTypes.func.isRequired,
  handleRemoveFromCart: PropTypes.func.isRequired,
  handleUpdateNote: PropTypes.func.isRequired,
  handleUpdateReceiptPrinterId: PropTypes.func.isRequired,
  handleLoading: PropTypes.func.isRequired,
  handleCheckout: PropTypes.func.isRequired,
  handleRetry: PropTypes.func.isRequired,
}

SaleCheckout.defaultProps = {
  fetchedPricing: {
    posItems: [],
    totalPrice: 0,
    subtotal: 0,
    taxAmount: 0,
  },
  loadingPrices: false,
  pricingError: "",
  processing: false,
  createError: "",
  note: "",
  receiptPrinterId: "",
}

export default SaleCheckout
